/**
 * Determines if the specified email address is valid.
 *
 * @param {string} emailAddress - the email address to check.
 * @return {boolean} true if valid; false otherwise
 */
export function isValidEmailAddress(emailAddress) {
    // This pattern was retrieved from here: https://stackoverflow.com/a/201378/214762 and modified to accept uppercase letters.
    // It is RFC 5322 compliant.
    const pattern =
        // eslint-disable-next-line no-control-regex
        /(?:[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return pattern.test(emailAddress);
}

/**
 * Obfuscates the specified email address using asterisks and returns the result.
 *
 * For example, joe.smith@example.com becomes j********@e******.com
 *
 * @param {string} emailAddress - the valid email address to obfuscate.
 * @returns {string} the obfuscated email address.
 */
export function obfuscateEmail(emailAddress) {
    const splitEmail = emailAddress.split('@');
    let result = '';
    for (let i = 0; i < splitEmail.length; i++) {
        const isLastComponent = i === splitEmail.length - 1;
        const splitComponent = splitEmail[i].split('.');
        result += splitComponent[0][0] + splitComponent[0].substring(1).replace(/./gi, '*');
        const count = isLastComponent ? splitComponent.length - 1 : splitComponent.length;
        for (let j = 1; j < count; j++) {
            result += '.' + splitComponent[j].replace(/./gi, '*');
        }
        if (isLastComponent) {
            result += '.' + splitComponent[splitComponent.length - 1];
        } else {
            result += '@';
        }
    }
    return result;
}
